import { polyfill } from 'es6-object-assign'
polyfill()
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { DevTools, initializeResponsiveState } from './app/Root';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { debug } from './utils';
const log = debug('lego:client-entry');
log('Client environment', process.env);

injectTapEventPlugin();

// ensure icons are generated for client-side
const favicon16 = require('assets/icons/web/favicon-16.ico') as any;
const favicon32 = require('assets/icons/web/favicon-32.ico') as any;
const favicon48 = require('assets/icons/web/favicon-48.ico') as any;
const favicon64 = require('assets/icons/web/favicon-64.ico') as any;
const favicon = require('assets/icons/web/favicon.ico') as any;

const rootEl = document.getElementById('html');
export const renderApp = () => {
	const Root = (require('./app/Root.tsx') as any).default
	return ReactDOM.render(
		<AppContainer>
				<Root />
		</AppContainer>,
		rootEl)
};

declare var module: any;
try {
	renderApp()
	if (module.hot) module.hot.accept('./app/Root', renderApp)
	ReactDOM.render(<DevTools />, document.getElementById('devTools'));
	initializeResponsiveState();
} catch (err) {
	log('Render error', err);
}



// WEBPACK FOOTER //
// ./src/client-entry.tsx